import React from "react";
import { Apple, Smartphone, Monitor, Laptop, ArrowLeft } from "lucide-react";
import { dataTrigger } from "@/analytics";
import { Button } from "@/ui/Button/Button";
import cls from "./styles.module.scss";

type LinkItem = {
  id: "ios" | "android" | "windows" | "macos";
  label: string;
  href: string;
  icon: React.ReactNode;
};

const LINKS: LinkItem[] = [
  {
    id: "ios",
    label: "iOS",
    href: "https://wiki.bk.yacob.ai/s/guide-ios",
    icon: <Apple />,
  },
  {
    id: "android",
    label: "Android",
    href: "https://wiki.bk.yacob.ai/s/guide-android",
    icon: <Smartphone />,
  },
  {
    id: "windows",
    label: "Windows",
    href: "https://wiki.bk.yacob.ai/s/guide-windows",
    icon: <Monitor />,
  },
  {
    id: "macos",
    label: "macOS",
    href: "https://wiki.bk.yacob.ai/s/guide-macos",
    icon: <Laptop />,
  },
];

type Props = {
  onBack?: () => void;
  title?: string;
  subtitle?: string;
};

export function InstructionScreen({
  onBack,
  title = "Инструкция",
  subtitle = "Выберите устройство",
}: Props) {
  const open = (href: string) => {
    window.open(href, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={cls.screen}>
      <div className={cls.wrap}>
        {onBack && (
          <button
            type="button"
            className={cls.backBtn}
            onClick={onBack}
            {...dataTrigger("bkn.instructions.back")}
          >
            <ArrowLeft className={cls.backIcon} />
            Назад
          </button>
        )}
        <div className={cls.card}>
          <div className={cls.head}>
            <div className={cls.title}>{title}</div>
            <div className={cls.subtitle}>{subtitle}</div>
          </div>

          <div className={cls.grid}>
            {LINKS.map((it) => (
              <Button
                key={it.id}
                variant="secondary"
                size="md"
                onClick={() => open(it.href)}
                leftIcon={it.icon}
                {...dataTrigger(`bkn.instructions.guide_${it.id}`)}
              >
                {it.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
